<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">Create Webhook</zm-button>
            <zm-button size="small" @click="fetchData()" plain class="btn-in-line">show all</zm-button>
        </zm-row>
        <zm-table :data="list" v-loading="loading">
            <zm-table-column prop="name" label="name"></zm-table-column>
            <zm-table-column prop="modifiedTime" label="modifiedTime" :formatter="setTime"></zm-table-column>
            <zm-table-column prop="createdTime" label="createdTime" :formatter="setTime"></zm-table-column>
            <zm-table-column>
                <template slot-scope="scope">
                    <zm-button type="icon" icon="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
                    <zm-button type="icon" icon="zm-icon-delete" @click="deleteWebhook(scope.row.id)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <zm-dialog :title="!form.id ? 'Create Webhook' : 'Edit Webhook'" :visible.sync="visible">
            <zm-form :model="form" :rules="rules" label-position="left" ref="form" label-width="180px">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="name" id="manage-webhook-name"></tip>
                    </div>
                    <zm-input size="small" v-model="form.name"></zm-input>
                </zm-form-item>
                <zm-form-item prop="endpoint">
                    <div slot="label">
                        <tip label="endpoint" id="manage-webhook-endpoint"></tip>
                    </div>
                    <zm-input size="small" v-model="form.endpoint"></zm-input>
                </zm-form-item>
                <zm-form-item prop="verificationToken">
                    <div slot="label">
                        <tip label="verificationToken" id="manage-webhook-verificationToken"></tip>
                    </div>
                    <zm-input size="small" v-model="form.verificationToken"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listWebhook, createWebhook, updateWebhook, deleteWebhook } from '@/api/manage'
import tip from 'components/ToolTip/index'
export default {
    name: 'manageWebhook',
    components: {
        tip
    },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: false,
            list: [],
            visible: false,
            form: {
                endpoint: '',
                verificationToken: '',
                id: '',
                name: ''
            },
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                endpoint: [
                    { required: true, message: 'please enter endpoint', trigger: 'blur' }
                ],
                verificationToken: [
                    { required: true, message: 'please enter verificationToken', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.fetchData()
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    methods: {
        setTime (row, column, cellValue, index) {
            return new Date(parseInt(cellValue)).toLocaleString()
        },
        fetchData () {
            this.loading = true
            listWebhook().then(response => {
                this.loading = false
                this.list = response
            }).catch(() => {
                this.loading = false
            })
        },
        deleteWebhook (id) {
            this.$confirm('This will delete the webhook. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteWebhook(id).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showCreate () {
            this.form.id = ''
            this.form.name = ''
            this.form.endpoint = ''
            this.form.verificationToken = ''
            this.visible = true
        },
        showEdit (row) {
            this.form.id = row.id
            this.form.name = row.name
            this.form.endpoint = row.endpoint
            this.form.verificationToken = row.verificationToken
            this.visible = true
        },
        save () {
            this.loading = true
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    if (!this.form.id) {
                        createWebhook(this.form).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Create success!',
                                type: 'success'
                            })
                            this.visible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        updateWebhook(this.form).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Edit success!',
                                type: 'success'
                            })
                            this.visible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        }
    }
}
</script>
